import { ExternalLink } from "@/components/ExternalLink";
import { siteLinks } from "@/config/branding";

/** Inline link to the support portal. */
export function SupportLink({ className }: { className?: string }) {
  return (
    <ExternalLink href={siteLinks.support} className={className}>
      contact support
    </ExternalLink>
  );
}
